export default __webpack_public_path__ + "static/media/2023-03-02T06_02_28.735Z_2_11.a8608ac1.jpeg";